var _path, _path2, _circle, _path3, _circle2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8L4.25 8",
    strokeWidth: 1.32353
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.6875L9.13971 12.6875C8.16509 12.6875 7.375 11.8974 7.375 10.9228L7.375 5.07721C7.375 4.10259 8.16509 3.3125 9.13971 3.3125L10.5 3.3125",
    strokeWidth: 1.32353
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4376,
    cy: 3.31235,
    r: 1.33218,
    transform: "rotate(-90 11.4376 3.31235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4359 11.3588C12.1707 11.3588 12.7663 11.9544 12.7663 12.6892C12.7663 13.424 12.1707 14.0196 11.4359 14.0196C10.7011 14.0196 10.1055 13.424 10.1055 12.6892C10.1055 11.9544 10.7011 11.3588 11.4359 11.3588Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4239,
    cy: 8.00187,
    r: 1.31844,
    transform: "rotate(-90 11.4239 8.00187)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.30058,
    cy: 7.99825,
    rx: 1.33378,
    ry: 1.33378,
    transform: "rotate(-90 3.30058 7.99825)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downline.c723b56f3f9bfa8668faf1c8249e8d5f.svg";